/**
 * @generated SignedSource<<9b5bd4e2a3d3e21fec40f03886206fa5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type KPIEditTitleMutation$variables = {
  routineId: string;
  title: string;
};
export type KPIEditTitleMutation$data = {
  readonly routine: {
    readonly update: {
      readonly routine: {
        readonly id: string;
        readonly title: string;
      } | null;
    } | null;
  } | null;
};
export type KPIEditTitleMutation = {
  response: KPIEditTitleMutation$data;
  variables: KPIEditTitleMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "routineId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "title"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "routineId"
      }
    ],
    "concreteType": "RoutineMutation",
    "kind": "LinkedField",
    "name": "routine",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "fields": [
              {
                "kind": "Variable",
                "name": "setTitle",
                "variableName": "title"
              }
            ],
            "kind": "ObjectValue",
            "name": "input"
          }
        ],
        "concreteType": "UpdateRoutinePayload",
        "kind": "LinkedField",
        "name": "update",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Routine",
            "kind": "LinkedField",
            "name": "routine",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "title",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "KPIEditTitleMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "KPIEditTitleMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "700dbf1d334321a1cc822f3a58389980",
    "id": null,
    "metadata": {},
    "name": "KPIEditTitleMutation",
    "operationKind": "mutation",
    "text": "mutation KPIEditTitleMutation(\n  $routineId: ID!\n  $title: String!\n) {\n  routine(id: $routineId) {\n    update(input: {setTitle: $title}) {\n      routine {\n        id\n        title\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "a5e64e2c97f33373a65faf3de9b6a202";

export default node;
